<div class="paragraph">
<p>For more information about logos, usage rules and guidelines, consult the branding guidelines for your project.</p>
</div>